import {Icon20Users3} from "@vkontakte/icons";
import {useRouteNavigator} from "@vkontakte/vk-mini-apps-router";
import {Avatar, Button, Card, Cell, Header, Separator, Spacing, Spinner} from "@vkontakte/vkui";
import React, {useEffect, useState} from 'react';
import {getWeeklyPlayerRating} from "../../services/player";

// Rating - блок для отображения рейтинга игроков
export function Rating() {
    const routeNavigator = useRouteNavigator();
    const [players, setPlayers] = useState([]);
    const [currentPlayerRank, setCurrentPlayerRank] = useState(0);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        getWeeklyPlayerRating().then(resp => {
            const data = resp.data.response;
            if (data === null) {
                return;
            }

            setCurrentPlayerRank(data.player_rank);

                if (data?.winners?.length !== 0) {
                    const players = data.winners.slice(0, 3).map(player => {
                        const points = player?.weekly_score || 0;
                        const games = player?.weekly_games || 0;
                        return (<Cell before={<Avatar src={player.avatar}/>}
                                      key={player.id}
                                      subtitle={`Points: ${points} | Games: ${games}`}
                                      disabled={true}
                                      className={"vkui-cell-text"}
                        >
                            <span className={"text-gray-400"}>{player.name}</span>
                        </Cell>)
                    })
                    setPlayers(players);
                }
        }).catch(err => {
            console.log("getWeeklyPlayerRating", err);
        }).finally(() => {
            setIsLoading(false);
        })
    }, []);

    const clickHandler = () => {
        // Переходим на страницу с рейтингом
        routeNavigator.push('/rating');
    }

    return (<div className={"flex w-full flex-col"}>
        <div className="w-full bg-gray-800 rounded-xl">
            <Header subtitle={currentPlayerRank > 0 ? `You are #${currentPlayerRank} 🔥` : "Weekly leaderboard"}>
                <div className={"flex items-center gap-2"}>
                    <span className={"text-gray-400"}>Top players</span>
                    {isLoading && <Spinner size={"small"}/>}
                </div>
            </Header>

            {/* Плейсхолдеры сохраняют высоту блока и убирают мерцание во время загрузки */}
            {isLoading && (
                <div className={"px-4 pb-4"}>
                    <div className={"animate-pulse flex flex-col gap-3"}>
                        <div className={"h-10 rounded bg-gray-700/60"}></div>
                        <div className={"h-10 rounded bg-gray-700/50"}></div>
                        <div className={"h-10 rounded bg-gray-700/40"}></div>
                    </div>
                </div>
            )}

            {!isLoading && <>
                {players.length <= 0 && (
                    <div className={"flex w-full items-center justify-center mb-3"}>
                        <p className={"text-xs text-gray-400"}>No rating data yet</p>
                    </div>
                )}

                {players.length > 0 && <>
                    {players}
                    <Spacing size={24}>
                        <Separator/>
                    </Spacing>
                    <Button
                        onClick={clickHandler}
                        before={<Icon20Users3/>}
                        appearance={"neutral"}
                        size={"s"}
                        align={"center"}
                        stretched={true}
                        mode={"link"}
                        className={"text-gray-400"}
                    >
                        Full rating
                    </Button>
                    <Spacing size={12}/>
                </>}
            </>}
        </div>
    </div>);
}
